import React from "react";
import Content from "../common/content/Content";

function PageWrapper({ children }) {
  return (
    <div className="section p0">
      <Content children={children} isContent={true} className={"mt-0"} />
    </div>
  );
}
export default PageWrapper;
